import SandhillsAccordion from '@Components/MuiWrappers/SandhillsAccordion';

const CategoryAccordionSection = (props) => {
    return (
        <>{(props?.AccordionCats?.length > 0) &&
            <section className='accordion-section'>
                <div id={props.isRentalAccordion ? 'rental-accordion' : 'accordion'} className='visually-hidden' />
                <div className='content'>
                    {props?.SectionTitle && <h2 className='section-title'>
                        <span className='section-title-text'>{props?.SectionTitle} </span>
                    </h2>}
                    {props.AccordionCats.map((accordionCat) =>
                        <SandhillsAccordion className='' accordionTitle={accordionCat.ListTitle} categories={accordionCat.Categories?.length > 1 ? accordionCat.Categories : accordionCat}
                            mapDetails={accordionCat.Categories?.length > 1} viewAllRoute={accordionCat.ViewAllButton} key={`accordion-section-${accordionCat.ListTitle}`} isRentalAccordion={props.isRentalAccordion} />)}
                </div>
            </section>}
        </>
    );
};

export default CategoryAccordionSection;